module.exports = __webpack_public_path__ + "b64896c6b7891e573c439010501060e8.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/logo.svg
// module id = 31
// module chunks = 0